export { DefaultPalette } from '@fluentui/theme';
